/* 標準カレンダー */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import moment from 'moment';
import Messages from '../molecules/Messages';
import { business_day_calendar as config, months } from '../Const';
import ja from '../lang/ja';
import DatePicker from 'react-datepicker';
import Paragraph from '../molecules/Paragraph';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Select from '../molecules/Select';
import { KeyValue } from '../types/KeyValue';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  value: string;
  message?: string;
  name?: string;
  placeholder?: string;
  help_msg?: string;
  disabled: boolean;
  looks_inactive?: boolean;
  // handleChange: (date: Date) => void;
  // handleBlur?: VoidFunction;
  sources: Array<KeyValue>;
  handleStoreChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ManagementStore: React.FC<Props> = ({
  id,
  label,
  need,
  value,
  message,
  name,
  placeholder,
  help_msg,
  disabled,
  looks_inactive,
  // handleChange,
  // handleBlur,
  sources,
  handleStoreChange,
}) => {
  const [is_open, setIsOpen] = useState(true);
  
  return (
    <ShelfInShelf 
      id={id}
      label={label}
      is_open={is_open}
      handleClick={() => setIsOpen(!is_open)}
    >
      <Select
        id={`select-${id}`}
        label={label}
        need={need}
        sources={sources}
        value={value}
        handleChange={handleStoreChange}
        name={name ?? ''}
        message=""
        help_msg=""
        disabled={disabled}
        suffix=""
        handleBlur={() => {}}
        with_empty_option={true}
        looks_inactive={false}
      />
    </ShelfInShelf>
  );
};

export default ManagementStore;
